import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { svgElement } from 'src/dictionaries/svg-sign';
import { CatalogService } from 'src/app/services/catalog.service';
import { DateService } from 'src/app/services/date.service';
import { ProjectService } from 'src/app/services/project.service';
import { ToastService } from 'src/app/services/toast.service';
import {
  ComplementInformationEnum, ComplementInformationSignEnum,
  DimensionInformationEnum, PendingStatusEnum,
  SignalingImageSituationEnum, SignalingTypeEnum,
  VerticalSignalingEnum, VerticalSignalizationTypeEnum
} from 'src/enumerators';
import { DeviceSignalingOccurrence, HorizontalSignalingOccurrence, VerticalSignaling, VerticalSignalingOccurrence } from 'src/models';
import { OccurrenceCreationModalComponent } from '../occurrence-creation-modal/occurrence-creation-modal.component';
import { OccurrenceService } from 'src/app/services/occurrence.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-display-summary',
  templateUrl: './display-summary.component.html',
  styleUrls: ['./display-summary.component.css', '../../catalog/display-catalog/display-catalog.component.css', '../../catalog/display-sign/display-sign.component.css']
})
export class DisplaySummaryComponent implements OnInit {

  private allowedWorkspaceIdsAuxiliarGroups: string[] = [
    'f35489a0-83bf-11ee-9246-d35f7bdbc3f2',
  ];

  currentSign: any = {};
  currentVertical: VerticalSignaling; // Serve pra enviar a vertical como deveria no checkout e usar como VerticalTraffic ao mesmo tempo

  // ENUMS PRO HTML
  pendingStatusEnum = PendingStatusEnum;
  complementInformationTypeEnum = ComplementInformationEnum;
  signTypeEnum = SignalingTypeEnum;
  verticalSignEnum = VerticalSignalingEnum;
  verticalSignTypeEnum = VerticalSignalizationTypeEnum;
  dimensionTypeEnum = DimensionInformationEnum;
  imageSituationEnum = SignalingImageSituationEnum;
  // ENUMS PRO HTML

  @Input() selectedSign: any;  // VerticalSignaling | HorizontalSignaling | DeviceSignaling;
  @Input() pendenciePage: boolean = false;

  @Output() approvedSign: EventEmitter<any> = new EventEmitter();

  @ViewChild('occurrenceCreationModal') occurrenceCreationModal: OccurrenceCreationModalComponent;
  @ViewChild('masterFilePositionModal') masterFilePositionModal: TemplateRef<any>;

  signalingOccurrenceIdList: string[] = []; //Lista de Ids das sinalizações com ocorrências

  // Posicionamento no arquivo-mestre durante a aprovação (opcional).
  masterFileModalRef: BsModalRef;
  projectMasterFile: { url: string; projectFileId: string; isPdf: boolean } | null = null;
  masterFileToSave: any = null; // objeto { id?, projectFileId, locations } emitido pelo app-master-file
  signSvg: string | undefined; // ícone da sinalização sendo aprovada
  referenceMarkers: Array<{ locations: any; svg: string }> = []; // outras sinalizações no mesmo arquivo-mestre
  loadingMasterFile = false;
  private _pendingApproveStatus: PendingStatusEnum;

  constructor(
    private _router: Router,
    private _catalogService: CatalogService,
    public dateService: DateService,
    private _occurrenceService: OccurrenceService,
    private _projectService: ProjectService,
    private _toastService: ToastService,
    private _modalService: BsModalService,
    ) { }

  ngOnInit(): void {
    this.getOccurrences()
  }

  // Troca de página para detalhes
  signDetailRouting(sign: any) {
    const id = sign.type == SignalingTypeEnum.Vertical ? sign.groupId : sign.id;
    const type = sign.type == SignalingTypeEnum.Vertical ? sign.order : sign.type;

    this._router.navigate([`/catalog/detail/${id}`], { queryParams: { type } });
  }

  updateStatus(status) {
    const ids = [this.selectedSign.id];
    if (this.selectedSign.type == SignalingTypeEnum.Horizontal) {
      this._catalogService.updateHorizontalStatus(ids, status).subscribe(res => {
        this.approvedSign.emit(this.selectedSign);
      });
    } else if (this.selectedSign.type == SignalingTypeEnum.Device) {
      this._catalogService.updateDeviceStatus(ids, status).subscribe(res => {
        this.approvedSign.emit(this.selectedSign);
      });
    } else {
      this._catalogService.updateTrafficSignStatus(ids, status).subscribe(res => {
        this.approvedSign.emit(this.selectedSign);
      });
    }
  }

  // Ponto de entrada do botão CONFIRMAR. Se a sinalização estiver vinculada a um
  // Projeto que tenha arquivo-mestre (imagem), oferece posicionar antes de aprovar.
  // Caso contrário, aprova direto. Posicionar é opcional.
  onConfirm(status: PendingStatusEnum) {
    const projectId = this.selectedSign?.projectId ?? this.selectedSign?.project?.id;
    if (!this.pendenciePage || !projectId) {
      this.updateStatus(status);
      return;
    }

    this.loadingMasterFile = true;
    this._pendingApproveStatus = status;
    this._projectService.getProject(projectId).subscribe(
      (project: any) => {
        const masterProjectFile = project?.projectFiles?.find((pFile) => pFile.masterFile);
        if (!masterProjectFile) {
          this.loadingMasterFile = false;
          this.updateStatus(status);
          return;
        }
        this._projectService.previewProjectFile(masterProjectFile.id).subscribe(
          (res: any) => {
            const mime = String(masterProjectFile?.file?.mimeType ?? '');
            const isPdf = mime ? /pdf$/i.test(mime) : /\.pdf(\?|$)/i.test(String(res?.url ?? ''));
            this.projectMasterFile = { url: res.url, projectFileId: masterProjectFile.id, isPdf };
            this.signSvg = svgElement.Signaling[this.selectedSign?.signCode];
            this.masterFileToSave = this.getExistingMasterFileRecord();
            // loadingMasterFile só volta a false quando o modal de fato abre (dentro
            // do forkJoin de loadReferenceMarkers); manter true até lá evita que o
            // botão CONFIRMAR reabilite e um segundo clique reentre em onConfirm
            // enquanto essa chamada ainda está em voo.
            this.loadReferenceMarkers(projectId, masterProjectFile.id, () => {
              this.loadingMasterFile = false;
              this.openMasterFilePositionModal();
            });
          },
          () => {
            this.loadingMasterFile = false;
            this.updateStatus(status);
          },
        );
      },
      () => {
        this.loadingMasterFile = false;
        this.updateStatus(status);
      },
    );
  }

  // Registro de arquivo-mestre já existente na sinalização (edições posteriores),
  // ou uma semente com o projectFileId para uma criação nova.
  private getExistingMasterFileRecord() {
    const seed = { projectFileId: this.projectMasterFile?.projectFileId };
    switch (this.selectedSign.type) {
      case SignalingTypeEnum.Horizontal:
        return this.selectedSign.horizontalSignalingMasterFile?.id
          ? this.selectedSign.horizontalSignalingMasterFile : seed;
      case SignalingTypeEnum.Device:
        return this.selectedSign.deviceSignalingMasterFile?.id
          ? this.selectedSign.deviceSignalingMasterFile : seed;
      default:
        return this.selectedSign.verticalSignalingMasterFile?.id
          ? this.selectedSign.verticalSignalingMasterFile : seed;
    }
  }

  openMasterFilePositionModal() {
    this.masterFileModalRef = this._modalService.show(this.masterFilePositionModal, {
      class: 'modal-dialog-centered modal-xl',
      backdrop: 'static',
    });
  }

  // Carrega outras sinalizações do projeto já posicionadas no mesmo arquivo-mestre
  // para exibir como referência (somente leitura) durante a aprovação.
  private loadReferenceMarkers(projectId: string, masterProjectFileId: string, done: () => void) {
    this.referenceMarkers = [];
    forkJoin({
      vertical: this._catalogService.getAllVerticalFromProject(projectId),
      horizontal: this._catalogService.getAllHorizontalFromProject(projectId),
      device: this._catalogService.getAllDeviceFromProject(projectId),
    }).subscribe({
      next: (res: any) => {
        const refs: Array<{ locations: any; svg: string }> = [];
        const add = (master: any, signCode: string, elementId: string, currentId: string) => {
          if (!master?.id || !master.locations?.length) return;
          if (master.projectFileId !== masterProjectFileId) return;
          if (elementId && currentId && elementId === currentId) return; // exclui a atual
          const svg = svgElement.Signaling[signCode];
          if (svg) refs.push({ locations: master.locations, svg });
        };
        (res.vertical || []).forEach((el: any) =>
          add(el.verticalSignalingMasterFile, el.trafficSigns?.[0]?.signCode, el.id, this.selectedSign?.verticalSignalingId));
        (res.horizontal || []).forEach((el: any) =>
          add(el.horizontalSignalingMasterFile, el.signCode, el.id, this.selectedSign?.id));
        (res.device || []).forEach((el: any) =>
          add(el.deviceSignalingMasterFile, el.signCode ?? el.deviceCode, el.id, this.selectedSign?.id));
        this.referenceMarkers = refs;
        done();
      },
      error: () => { this.referenceMarkers = []; done(); },
    });
  }

  // Recebe as coordenadas emitidas pelo app-master-file.
  receiveMasterFile(event: any) {
    this.masterFileToSave = event;
  }

  // Confirma o posicionamento (se houver) e então aprova.
  confirmWithPosition() {
    const status = this._pendingApproveStatus;
    const data = this.masterFileToSave;
    const hasLocation = data?.locations?.[0]?.pointA?.x != null;

    if (!hasLocation) {
      this.approveWithoutPosition();
      return;
    }

    data.projectFileId = data.projectFileId || this.projectMasterFile?.projectFileId;
    this.persistMasterFile(data).subscribe(
      () => {
        this.masterFileModalRef?.hide();
        this.updateStatus(status);
      },
      () => this._toastService.showError('Não foi possível salvar a posição no arquivo-mestre.'),
    );
  }

  // Aprova sem posicionar (posicionamento é opcional).
  approveWithoutPosition() {
    const status = this._pendingApproveStatus;
    this.masterFileModalRef?.hide();
    this.updateStatus(status);
  }

  // Fechar pelo × cancela a aprovação (o CONFIRMAR/APROVAR já fecham o modal
  // sozinhos ao concluir); avisa o usuário em vez de fechar silenciosamente
  // sem nenhum feedback de que a aprovação não foi feita.
  closeMasterFileModal() {
    this.masterFileModalRef?.hide();
    this._toastService.showInfo('Aprovação cancelada.');
  }

  private persistMasterFile(data: any) {
    const isUpdate = !!data.id;
    switch (this.selectedSign.type) {
      case SignalingTypeEnum.Horizontal:
        return isUpdate
          ? this._projectService.updateHorizontalMasterFile(this.selectedSign.id, data)
          : this._projectService.createHorizontalMasterFile(this.selectedSign.id, data);
      case SignalingTypeEnum.Device:
        return isUpdate
          ? this._projectService.updateDeviceMasterFile(this.selectedSign.id, data)
          : this._projectService.createDeviceMasterFile(this.selectedSign.id, data);
      default: {
        const verticalId = this.selectedSign.verticalSignalingId ?? this.selectedSign.id;
        return isUpdate
          ? this._projectService.updateVerticalMasterFile(verticalId, data)
          : this._projectService.createVerticalMasterFile(verticalId, data);
      }
    }
  }

  stringToFloatFixed(string): string {
    let coefficient = Math.pow(10, 5);
    string = Math.floor(string * coefficient) / coefficient;
    let options = {
      minimumFractionDigits: 0,
      maximumFractionDigits: 5,
      useGrouping: false,
    };
    return string.toLocaleString('pt-BR', options);
  }

  imageExists() {
    if (this.selectedSign.type == SignalingTypeEnum.Vertical) {
      return this.selectedSign.verticalSignalingFiles.length > 0;
    } else if (this.selectedSign.type == SignalingTypeEnum.Horizontal) {
      return this.selectedSign.horizontalSignalingFiles.length > 0;
    } else {
      return this.selectedSign.deviceSignalingFiles.length > 0;
    }
  }

  getImageList() {
    if (this.selectedSign.type == SignalingTypeEnum.Vertical) {
      return this.selectedSign.verticalSignalingFiles;
    } else if (this.selectedSign.type == SignalingTypeEnum.Horizontal) {
      return this.selectedSign.horizontalSignalingFiles;
    } else {
      return this.selectedSign.deviceSignalingFiles;
    }
  }

  getImageEmpty(situation: SignalingImageSituationEnum): boolean {
    let situationEmpty = true;
    this.getImageList().some(file => {
      if (file.situation == situation) {
        situationEmpty = false;
        return true
      }
    });
    return situationEmpty;
  }

  // Retorna qual é o tipo da informação complementar sabendo qual é o tipo da placa WARNING/REGULATION
  complementType(item): ComplementInformationSignEnum {
    if (item.complementInformationType == ComplementInformationEnum.Additional) {
      if (item.verticalType == VerticalSignalizationTypeEnum.Warning) {
        return ComplementInformationSignEnum.AdditionalWarning;
      } else {
        return ComplementInformationSignEnum.AdditionalRegulation;
      }
    } else {
      if (item.verticalType == VerticalSignalizationTypeEnum.Warning) {
        return ComplementInformationSignEnum.IncorporatedWarning;
      } else {
        return ComplementInformationSignEnum.IncorporatedRegulation;
      }
    }
  }

  newOccurrence() {
    if(
      this.selectedSign.type == SignalingTypeEnum.Vertical &&
      (
        this.signalingOccurrenceIdList.includes(this.selectedSign.verticalSignalingId) ||
        this.signalingOccurrenceIdList.includes(this.selectedSign.id)
      )
    ) return;

    this.occurrenceCreationModal.openModal(this.selectedSign);
  }


  getOccurrences() {
    this._occurrenceService.getDeviceOccurrences().subscribe(
      (deviceOccurrences: DeviceSignalingOccurrence[]) => {
        const deviceIdList = deviceOccurrences.map(occ => occ.deviceSignalingId)
        this.signalingOccurrenceIdList = [...this.signalingOccurrenceIdList, ...deviceIdList]
      }
    )

    this._occurrenceService.getHorizontalOccurrences().subscribe(
      (horizontalOccurrences: HorizontalSignalingOccurrence[]) => {
        const horizontalIdList = horizontalOccurrences.map(occ => occ.horizontalSignalingId)
        this.signalingOccurrenceIdList = [...this.signalingOccurrenceIdList, ...horizontalIdList]
      }
    )

    this._occurrenceService.getVerticalOccurrences().subscribe(
      (verticalOccurrences: VerticalSignalingOccurrence[]) => {
        const verticalIdList = verticalOccurrences.map(occ => occ.verticalSignalingId)
        this.signalingOccurrenceIdList = [...this.signalingOccurrenceIdList, ...verticalIdList]
      }
    )
  }

    shouldDisplayAuxiliarGroup(): boolean {
      const environmentEndpoint = environment.endpoint();
  
      return (
        this.allowedWorkspaceIdsAuxiliarGroups.includes(this.currentSign.workspaceId) || !environment.production || environmentEndpoint.includes('hellius.dev.')
      );
    };

  // Download da imagem da sinalização
  downloadFileSign(fileUrl: string) {
    window.open(fileUrl, 'Download');
  }
}
